import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingFlixMediaContentFailedEvent implements GATrackingEvent {

  constructor(
    private type: string,
    private event: string,
    private category: string,
    private action?: string,
    private label?: string,
    private gtmCustom?: any) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.FlixMediaContentFailed;
  }

  getPayload(): any {
    return {
      type: this.type,
      event: this.event,
      category: this.category,
      label: this.label,
      gtmCustom: this.gtmCustom
    };
  }
}
